import enGbFlag from "flag-icons/flags/1x1/gb.svg"; // UK
import ieFlag from "flag-icons/flags/1x1/ie.svg"; // Ireland
import skFlag from "flag-icons/flags/1x1/sk.svg"; // Slovakia
import ukFlag from "flag-icons/flags/1x1/ua.svg"; // Ukraine
import dkFlag from "flag-icons/flags/1x1/dk.svg"; // Denmark
import seFlag from "flag-icons/flags/1x1/se.svg"; // Sweden
import nlFlag from "flag-icons/flags/1x1/nl.svg"; // Netherlands
import deFlag from "flag-icons/flags/1x1/de.svg"; // Germany
import frFlag from "flag-icons/flags/1x1/fr.svg"; // France
import plFlag from "flag-icons/flags/1x1/pl.svg"; // Poland
import esFlag from "flag-icons/flags/1x1/es.svg"; // Spain
import czFlag from "flag-icons/flags/1x1/cz.svg"; // Czech
import beFlag from "flag-icons/flags/1x1/be.svg"; // Belgium
import itFlag from "flag-icons/flags/1x1/it.svg"; // Italy
import fiFlag from "flag-icons/flags/1x1/fi.svg"; // Finland
import noFlag from "flag-icons/flags/1x1/no.svg"; // Norway
import lvFlag from "flag-icons/flags/1x1/lv.svg"; // Latvia
import chFlag from "flag-icons/flags/1x1/ch.svg"; // Switzerland
import ptFlag from "flag-icons/flags/1x1/pt.svg"; // Portugal
import xxFlag from "flag-icons/flags/1x1/xx.svg"; // Other
import zaFlag from "flag-icons/flags/1x1/za.svg"; // South Africa
import huFlag from "flag-icons/flags/1x1/hu.svg"; // Hungary

import { COUNTRIES } from "@sisuwellness/utilities/User/UserProfile"; // Unknown

export const getFlagPath = countryCode => {
    switch (countryCode) {
        case COUNTRIES.UNITED_KINGDOM:
            return { src: enGbFlag, alt: "gb-flag" };
        case COUNTRIES.GERMANY:
            return { src: deFlag, alt: "de-flag" };
        case COUNTRIES.IRELAND:
            return { src: ieFlag, alt: "ie-flag" };
        case COUNTRIES.SWITZERLAND:
            return { src: chFlag, alt: "ch-flag" };
        case COUNTRIES.SLOVAKIA:
            return { src: skFlag, alt: "sk-flag" };
        case COUNTRIES.OTHER:
            return { src: xxFlag, alt: "other-flag" };
        case COUNTRIES.DENMARK:
            return { src: dkFlag, alt: "dk-flag" };
        case COUNTRIES.SWEDEN:
            return { src: seFlag, alt: "se-flag" };
        case COUNTRIES.NETHERLANDS:
            return { src: nlFlag, alt: "nl-flag" };
        case COUNTRIES.FRANCE:
            return { src: frFlag, alt: "fr-flag" };
        case COUNTRIES.POLAND:
            return { src: plFlag, alt: "pl-flag" };
        case COUNTRIES.SPAIN:
            return { src: esFlag, alt: "es-flag" };
        case COUNTRIES.CZECHIA:
            return { src: czFlag, alt: "cz-flag" };
        case COUNTRIES.BELGIUM:
            return { src: beFlag, alt: "be-flag" };
        case COUNTRIES.LATVIA:
            return { src: lvFlag, alt: "lv-flag" };
        case COUNTRIES.ITALY:
            return { src: itFlag, alt: "it-flag" };
        case COUNTRIES.FINLAND:
            return { src: fiFlag, alt: "fi-flag" };
        case COUNTRIES.NORWAY:
            return { src: noFlag, alt: "no-flag" };
        case COUNTRIES.SOUTH_AFRICA:
            return { src: zaFlag, alt: "za-flag" };
        case COUNTRIES.UKRAINE:
            return { src: ukFlag, alt: "uk-flag" };
        case COUNTRIES.PORTUGAL:
            return { src: ptFlag, alt: "pt-flag" };
        case COUNTRIES.HUNGARY:
            return { src: huFlag, alt: "hu-flag" };
        default:
            return { src: enGbFlag, alt: "gb-flag" };
    }
};
